var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M26.4853 26.4853L9.51478 9.51476",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2_2",
    d: "M26.4852 9.51476L9.51466 26.4853",
    stroke: "white",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLight);
export default __webpack_public_path__ + "static/media/closeLight.5ae8706661a0ced83d179845026e8eec.svg";
export { ForwardRef as ReactComponent };